import { render, staticRenderFns } from "./callback.vue?vue&type=template&id=908a0c04"
import script from "./callback.vue?vue&type=script&lang=ts"
export * from "./callback.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports